import React from 'react';
import Chapter from './Odj/Chapter.js';
import Utils from '../Utils/Utils';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import ImageCompare from '../Sdk/ImageCompare';


class ColorSquares {
  constructor(ctx, canvas) {
    this.ctx = ctx
    this.canvas = canvas
    this.init();
  }
  
	init() {
		this.draw();
	};

	draw() {
		this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
		
		for (var i = 0; i < 24; i ++) {
		  for (var j = 0; j < 24; j++) {
		  	this.drawRect(i, j);
		  }
		}
	};

	drawRect(x, y) {
		let red = this.randomHue();
		let green = this.randomHue();
		let blue = this.randomHue();
		
		this.ctx.beginPath();
		this.ctx.rect(x * 25, y * 25, 24, 24);
		this.ctx.fillStyle = `rgb(${red},${green},${blue})`;
		this.ctx.fill();
	};

	randomHue() {
		let num = Math.floor(Math.random() * 256) + 1;
		return num;
	};
}

export default class Odj extends React.Component {

  state = {
    chapters: [],
    currentChapterIndex: -1,
    isBroadcasting: false,
    mediaSource: false
  }
  
  async componentDidMount() {
    let chapters = await window.sdk.live.getLiveChapters(window.programId);
    this.setState({
      chapters: chapters,
      isBroadcasting: window.sdk.live.streamInfo.program.live_state
    });
    
    
    window.sdk.on('monitorStream', () => {
      this.setState({
        isBroadcasting: window.sdk.live.isInPublicLive()
      })
    });
    
    let lastClicked = window.sdk.live.getLastClickedCuepoint('chapter');
    if(lastClicked) {
      let interval = setInterval(() => {
        if(this.refs['chapter-' + lastClicked]) {
            this.refs['chapter-' + lastClicked].setCurrent(true);
            clearInterval(interval)
        }
      }, 300)
    }
        
    window.sdk.on('noLiveAnymore', (chapterId) => {
      if(this.refs['chapter-' + chapterId])
        this.refs['chapter-' + chapterId].setCurrent(false);
    });
    

  }
  
  addMedia = async () => {
    this.setState({
      mediaSource: true
    })
    while(!document.getElementById('canvas_mediaIn')) {
      await Utils.sleep(100);
    }
    /*this.canvas = document.getElementById('canvas');
    this.ctx = this.canvas.getContext('2d');
    let c = new ColorSquares(this.ctx, this.canvas)*/
    this.imageCompare = new ImageCompare({
        video: document.getElementById('video_media'), 
        canvasIn: document.getElementById('canvas_mediaIn'), 
        canvasTmp: document.getElementById('canvas_mediaTmp'), 
        canvasOut: document.getElementById('canvas_mediaOut'),
      },
      (image) => {
        console.log('yoyo');
        window.sdk.live.streamMedia(image)
      });
    this.imageCompare.capture();
  }
  
  streamMedia = () => {
    window.sdk.live.streamMedia(this.canvas.toDataURL('image/jpeg', 1.0))
  }

  
  render() {
    return (
      <div className={ 'odj' } id="tab_inner">
        
        <Button onClick={ this.addMedia  }>Ajouter une source media</Button>
        
        {this.state.mediaSource &&
          <div>
            <video controls id="video_media"></video>
            <canvas style={{ display: 'none'}} id="canvas_mediaIn" width="640" height="480"></canvas>
            <canvas style={{ display: 'none'}} id="canvas_mediaTmp" width="640" height="480"></canvas>
            <canvas id="canvas_mediaOut" width="640" height="480"></canvas>
            <Button onClick={ this.streamMedia }>Stream media source</Button>    
          </div>
        }
        
        <List dense={ true }>
          {this.state.chapters.map((chapter, index) => {
              return <Chapter ref={'chapter-' + chapter.id} key={ index } isBroadcasting={ this.state.isBroadcasting } chapter={ chapter } />
          })}
        </List>
        
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Manager/Odj.js